import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ThemeService {

  constructor() { }

  applyTheme(themeConfig: any): void {
    if (!themeConfig) return;

    const root = document.documentElement;

    // Apply CSS custom properties
    if (themeConfig.primaryTextColor) {
      root.style.setProperty('--primary-text-color', themeConfig.primaryTextColor);
    }
    if (themeConfig.primaryColor) {
      root.style.setProperty('--primary-color', themeConfig.primaryColor);
    }
    if (themeConfig.secondaryColor) {
      root.style.setProperty('--secondary-color', themeConfig.secondaryColor);
    }
    if (themeConfig.buttonPrimaryColor) {
      root.style.setProperty('--button-primary-color', themeConfig.buttonPrimaryColor);
    }
    if (themeConfig.buttonPrimaryTextColor) {
      root.style.setProperty('--button-primary-text-color', themeConfig.buttonPrimaryTextColor);
    }
    if (themeConfig.buttonHoverColor) {
      root.style.setProperty('--button-hover-color', themeConfig.buttonHoverColor);
    }
    if (themeConfig.applyButtonColor) {
      root.style.setProperty('--apply-btn-color', themeConfig.applyButtonColor);
    }
  }
}
